import { useMemo } from 'react'

import type { InputMultiSelectProps } from '../../input-multi-select.types'

import type { IButtonProps } from '~/components/button'
import type { TIconProps } from '~/components/icon'

type UseControlInteractionsSizeReturn = {
  clearButtonSize: IButtonProps['size']
  symbolSize: TIconProps['size']
}

export function useControlInteractionsSize(
  size: InputMultiSelectProps['size']
): UseControlInteractionsSizeReturn {
  return useMemo(() => {
    const clearButtonSize = size !== 'md' ? 'ml' : 'md'

    const symbolSize = size !== 'md' ? 'small' : 'tiny'

    return {
      clearButtonSize,
      symbolSize,
    }
  }, [size])
}
